const PUBLIC_PATH_PREFIXES = [
  "/sign-in",
  "/sign-up",
  "/password-reset",
  "/notif/unsubscribe/",
];

export function isPublicRoutePath(path: string): boolean {
  return PUBLIC_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix)
  );
}

export function isPublicHashLocation(hash: string): boolean {
  const path = hash.startsWith("#") ? hash.slice(1) : hash;
  return isPublicRoutePath(path);
}
